import React, {Component} from 'react';
import {connect} from 'react-redux'
import Loading from '../Loading'
import GridWithForm from '../grid/GridWithForm'
import {baisImportsSelected, baisVirszemesImportActions} from "../../actions/importsActions"
import {
  getFormatterForKodif, getSelectFilterCfg,
  getTextFilterCfg,
} from '../grid/ColumnHelpers'
import {addUrlQuery} from '../../actions/uiActions'
import {getKlasifikatorsFieldCfg} from "../forms/FormHelpers";
import {showErrorMsg} from '../../actions/uiActions'

const getColumns = ({kodif}) => {
  return [
    {
      dataField: 'file.filename',
      text: 'Fails',
      filterCfg: getTextFilterCfg()
    }, {
      dataField: 'tips',
      text: 'Tips',
      formatter: getFormatterForKodif(kodif.baisImportsTipi),
      filterCfg: getSelectFilterCfg(kodif.baisImportsTipi)
    }
  ]};

const  getFormFieldCfgs = ({kodif, user}) => {
  const tiesibas = user.tiesibas
  let fieldCfg
  if (tiesibas.includes('BAIS_LABOT') || (tiesibas.includes('BAIS_VU_KVAL_LABOT') && tiesibas.includes('BAIS_VU_PAMAT_LABOT'))) {
    fieldCfg = getKlasifikatorsFieldCfg(kodif, 'baisImportsTipi')
  } else if (tiesibas.includes('BAIS_VU_KVAL_LABOT')) {
    fieldCfg = getKlasifikatorsFieldCfg(kodif, 'baisImportsTipiKval')
  } else if (tiesibas.includes('BAIS_VU_PAMAT_LABOT')) {
    fieldCfg = getKlasifikatorsFieldCfg(kodif, 'baisImportsTipiPamat')
  }
  return [
    {
      ...fieldCfg,
      name: 'tips',
      renderer: getFormatterForKodif(kodif.baisImportsTipi)
    },
    {
      label: 'Faila ielāde',
      name: 'file_info_id',
      type: 'file',
      required: true,
    },
  ]};

class BaisImports extends Component {

  getCurrentQueryGrupas = () => {
    const {query} = this.props
    const ef = query && query.ef ? JSON.parse(query.ef) : {}
    return ef.grupas ? ef.grupas.split(',') : []
  }

  render() {
    const { bais_virszemes_imports, user } = this.props
    if(bais_virszemes_imports.loading) {
      return (<Loading/>)
    }

    if(!this.columns){
      this.columns = getColumns({
        kodif: this.props.kodif
      })
    }

    if(!this.formFieldCfgs){
      this.formFieldCfgs = getFormFieldCfgs({
        kodif: this.props.kodif,
        user: user
      })
    }

    return (
      <GridWithForm
        {...this.props}
        columns={this.columns}
        formFieldCfgs={this.formFieldCfgs}
        storeObj={this.props.bais_virszemes_imports}
        formWidthGuiOption="bais_imports_form_width"
        metadataFormCfg="bais_virszemes_imports"
        tiesibasLabot="BAIS_VU_IMPORT_SAVE"
        handleDelete={null}
        editable={false}
      />
    )

  }

}

const mapStateToProps = ({bais_virszemes_imports, kodif, location, user}) => ({bais_virszemes_imports, kodif, query: location.query, user})

export default connect(mapStateToProps, {
  selectedAct : baisImportsSelected,
  addUrlQuery,
  ...baisVirszemesImportActions,
  showErrorMsg
})(BaisImports)
